<template>
  <a-row :gutter="24">
    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="受委托进行招租活动" prop="hasEntrustRent">
            <a-radio-group v-model="form.hasEntrustRent">
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="出租方名称" prop="lessorName">
            <a-input v-model="form.lessorName" placeholder="请输入出租方名称" :disabled="form.hasEntrustRent == 0"/>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item label="出租方类型" prop="lessorType">
            <a-radio-group v-model="form.lessorType" :disabled="form.hasEntrustRent == 0">
              <a-radio :value="1">法人</a-radio>
              <a-radio :value="2">自然人</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="出租方联系人" prop="businessPrincipal">
            <a-input
              v-model="form.businessPrincipal"
              placeholder="请输入出租方联系人"
            />
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item
            label="出租方联系人电话"
            prop="principalContactNumber"
          >
            <a-input
              v-model="form.principalContactNumber"
              placeholder="请输入出租方联系人电话"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24" v-if="form.lessorType == 2">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="出租方证件类型" prop="personCertType" >
            <a-radio-group v-model="form.personCertType" :disabled="form.hasEntrustRent == 0">
            <a-radio style="margin: 4px 0px" :value="0">身份证</a-radio>
            <a-radio style="margin: 4px 0px" :value="1">护照</a-radio>
            <a-radio style="margin: 4px 0px" :value="2">军官证</a-radio>
            <a-radio style="margin: 4px 0px" :value="3">士兵证</a-radio>
            <a-radio style="margin: 4px 0px" :value="4">回乡证</a-radio>
            <a-radio style="margin: 4px 0px" :value="5">户口本</a-radio>
            <a-radio style="margin: 4px 0px" :value="6">外国护照</a-radio>
            <a-radio style="margin: 4px 0px" :value="15">台胞证</a-radio>
            <a-radio style="margin: 4px 0px" :value="16"
              >港澳台居民身份证</a-radio
            >
            <a-radio style="margin: 4px 0px" :value="99">其它</a-radio>
          </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item label="出租方证件号码" prop="personCertNumber" >
            <a-input v-model="form.personCertNumber" placeholder="请输入出租方证件号码" :disabled="form.hasEntrustRent == 0"/>
          </a-form-model-item>
        </a-col>
        </a-row>
    </a-col>

    <a-col :span="24" v-if="form.lessorType == 1">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="出租方证件类别" prop="certType">
            <a-radio-group v-model="form.certType" :disabled="form.hasEntrustRent == 0">
              <a-radio :value="19">统一社会信用代码</a-radio>
              <a-radio :value="99">其他</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item label="出租方证件号码" prop="certNumber">
            <a-input v-model="form.certNumber" placeholder="请输入出租方证件号码" :disabled="form.hasEntrustRent == 0"/>
          </a-form-model-item>
        </a-col>
        </a-row>
    </a-col>

    <a-col :span="24" v-if="form.lessorType == 1">
      <a-row :gutter="24">
        <a-col :span="24">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item label="出租方法定代表人" prop="legalPerson">
                <a-input v-model="form.legalPerson" placeholder="请输入出租方法定代表人" :disabled="form.hasEntrustRent == 0"/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      </a-col>
      

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="地区" prop="country">
            <a-form-model-item
              prop="country"
              :style="{
                display: 'inline-block',
                width: 'calc(50% - 12px)',
              }"
            >
              <a-select v-model="form.country" placeholder="请选择国家">
                <a-select-option value="1">中国</a-select-option>
                <a-select-option value="2">分钟</a-select-option>
                <a-select-option value="2">秒</a-select-option>
                <a-select-option value="3">天</a-select-option>
              </a-select>
            </a-form-model-item>
            <span
              :style="{
                display: 'inline-block',
                width: '20px',
                textAlign: 'center',
              }"
            >
            </span>
            <a-form-model-item
              prop="registerProvince"
              :style="{
                display: 'inline-block',
                width: 'calc(50% - 12px)',
              }"
            >
              <a-select v-model="form.registerProvince" placeholder="请选择省/市/区（县）">
                <a-select-option value="1">上海</a-select-option>
                <a-select-option value="2">分钟</a-select-option>
                <a-select-option value="2">秒</a-select-option>
                <a-select-option value="3">天</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item label="注册地(地址)" prop="registAddress">
            <a-input v-model="form.registAddress" placeholder="输入注册地（地址）"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24" v-if="form.lessorType == 1">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="出租方是否国资" prop="hasLessorStateOwned">
            <a-radio-group v-model="form.hasLessorStateOwned" :disabled="form.hasEntrustRent == 0">
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item label="出租方经济类型" prop="economicTypeLessor">
            <a-select v-model="form.economicTypeLessor" placeholder="请选择出租方经济类型" :disabled="form.hasEntrustRent == 0">
                <a-select-option value="A05001">国资监管机构/政府部门</a-select-option>
                <a-select-option value="A05002">国有独资公司（企业）/国有全资企业</a-select-option>
                <a-select-option value="A05003">国有控股企业</a-select-option>
                <a-select-option value="A05004">国有事业单位，国有社团等</a-select-option>
                <a-select-option value="A05006">国有参股企业</a-select-option>
                <a-select-option value="A050070001">集体</a-select-option>
                <a-select-option value="A050070002">私营</a-select-option>
                <a-select-option value="A05008">外资企业</a-select-option>
                <a-select-option value="A05009">其他</a-select-option>
                <a-select-option value="A05010">国有实际控制企业</a-select-option>
              </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24" v-if="form.lessorType == 1 &&form.hasLessorStateOwned == 1">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="所属集团" prop="groupDepartmentName">
            <a-input v-model="form.groupDepartmentName" placeholder="请输入所属集团" :disabled="form.hasEntrustRent == 0"/>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item label="所属集团统一社会信用代码" prop="groupDepartmentCode">
            <a-input v-model="form.groupDepartmentCode" placeholder="请输入所属集团统一社会信用代码" :disabled="form.hasEntrustRent == 0"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24" v-if="form.lessorType == 1 &&form.hasLessorStateOwned == 1">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="监管部门" prop="regulatoryAuthorities">
            <a-input v-model="form.regulatoryAuthorities" placeholder="请输入监管部门" :disabled="form.hasEntrustRent == 0"/>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item label="监管部门统一社会信用代码" prop="regulatoryAuthoritiesCode">
            <a-input v-model="form.regulatoryAuthoritiesCode" placeholder="请输入监管部门统一社会信用代码" :disabled="form.hasEntrustRent == 0"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24" v-if="form.lessorType == 2 ">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="电子邮件" prop="email">
            <a-input v-model="form.email" placeholder="请输入电子邮件"/>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item label="通讯地址" prop="mailingAddress">
            <a-input v-model="form.mailingAddress" placeholder="请输入通讯地址"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

  </a-row>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => null,
    },
  },
};
</script>

<style>
</style>